import { createAction } from 'redux-actions';
import { callApi, getEndpoint } from '../../../utils/api';

export const GET_ELIGIBLE_AGREEMENTS = 'GET_ELIGIBLE_AGREEMENTS';

export default function eligibleAgreements(
  state = {
    agreementsEligibilityList: [],
    eligibilityFailed: false,
    eligibilitySuccess: false,
    eligibilityLoading: false,
  },
  { payload, type }
) {
  switch (type) {
    case `${GET_ELIGIBLE_AGREEMENTS}_PENDING`:
      return {
        ...state,
        eligibilityFailed: false,
        eligibilitySuccess: false,
        eligibilityLoading: true,
      };
    case `${GET_ELIGIBLE_AGREEMENTS}_FULFILLED`:
      return {
        ...state,
        eligibilityFailed: false,
        eligibilitySuccess: true,
        eligibilityLoading: false,
        agreementsEligibilityList: payload.body,
      };
    case `${GET_ELIGIBLE_AGREEMENTS}_REJECTED`:
      return {
        ...state,
        eligibilityFailed: true,
        eligibilitySuccess: false,
        eligibilityLoading: false,
        agreementsEligibilityList: [],
      };

    default:
      return state;
  }
}

export const getEligibleAgreementsList = () => {
  return (dispatch) => {
    const action = createAction(GET_ELIGIBLE_AGREEMENTS)(
      callApi(getEndpoint('eligibleAgreements'))
    );
    dispatch(action);
  };
};
